import { render, staticRenderFns } from "./MapPointConfirmation.vue?vue&type=template&id=7477c134&scoped=true"
import script from "./MapPointConfirmation.vue?vue&type=script&lang=js"
export * from "./MapPointConfirmation.vue?vue&type=script&lang=js"
import style0 from "./MapPointConfirmation.vue?vue&type=style&index=0&id=7477c134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7477c134",
  null
  
)

export default component.exports